import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import Button from '@atlaskit/button/loading-button';
import Tooltip from '@atlaskit/tooltip';
import { SpotlightTarget } from '@atlaskit/onboarding';

import { ShortcutVisualizer } from '@confluence/shortcuts/entry-points/ShortcutVisualizer';
import { EDITOR2_SHORTCUTS } from '@confluence/shortcuts/entry-points/confluence-shortcuts';

// eslint-disable-next-line import/no-cycle
import { WideTooltip, TooltipText } from './PublishButtonWithMoreOptions';
import { preloadPublishModal } from './preloadPublishModal';
import { i18nShared } from './i18nShared';

const i18n = defineMessages({
	publishButtonTooltip: {
		id: 'publish-modal.default-publish-button-tooltip',
		description:
			'Tooltip for publish button (or split button) to inform user that they can change restrictions and location of the page',
		defaultMessage: 'Select and confirm publish settings',
	},
});

export type Props = {
	saveDraft?: () => void;
	openModalWithAnalytics: (string) => () => void;
	savingInProgress: boolean;
	publishButtonDisabled: boolean | undefined;
};

export const DefaultPublishModalButton = ({
	saveDraft,
	openModalWithAnalytics,
	savingInProgress,
	publishButtonDisabled,
}: Props) => (
	<Tooltip
		component={WideTooltip}
		content={
			<TooltipText>
				<FormattedMessage {...i18n.publishButtonTooltip} />
				<ShortcutVisualizer shortcut={EDITOR2_SHORTCUTS.PUBLISH} isEditorShortcut isTooltip />
			</TooltipText>
		}
	>
		<SpotlightTarget name="publish-button">
			<Button
				appearance="primary"
				onMouseDown={() => preloadPublishModal(saveDraft)}
				onMouseEnter={() => preloadPublishModal(saveDraft)}
				onFocus={() => preloadPublishModal(saveDraft)}
				onClick={openModalWithAnalytics('PublishModalPublishMoreActionsButton')}
				testId="publish-button"
				isLoading={savingInProgress}
				isDisabled={publishButtonDisabled}
			>
				<FormattedMessage {...i18nShared.publishButton} />
			</Button>
		</SpotlightTarget>
	</Tooltip>
);
